/*!

=========================================================
* Material Dashboard React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
//import Dashboard from "@material-ui/icons/Dashboard";
//import DashboardPage from "views/Dashboard/Dashboard.js";
import MenuIcon from "@mui/icons-material/Menu";
import ManageAccounts from "@mui/icons-material/ManageAccounts";
import DepartureBoardIcon from "@mui/icons-material/DepartureBoard";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import InfoIcon from "@mui/icons-material/Info";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import WarningIcon from "@mui/icons-material/Warning";
import Tracuuthongtin from "views/Tracuuthongtin/Tracuuthongtin.js";
import Danhmucdungchung from "views/Danhmuc/Danhmucdungchung.js";
import Danhmucdonvi from "views/Danhmuc/Danhmucdonvi.js";
import Danhmucphuongtien from "views/Danhmuc/Danhmucphuongtien.js";
import Danhmucbenxe from "views/Danhmuc/Danhmucbenxe.js";
import Danhmuctuyenxe from "views/Danhmuc/Danhmuctuyenxe.js";
import Danhmuctuyenxebuyt from "views/Danhmuc/Danhmuctuyenxebuyt.js";
import Danhmucxedien from "views/Danhmuc/Danhmucxedien.js";
import Danhmuctuyenxedien from "views/Danhmuc/Danhmuctuyenxedien.js";
import Danhmucttdangkiem from "views/Danhmuc/Danhmucttdangkiem.js";
import Cosodaotao from "views/Danhmuc/Cosodaotao.js";
import Trungtamsathach from "views/Daotaosathach/Trungtamsathach.js";
import Xacnhanhopdong from "views/Xacnhanhopdong/Xacnhanhopdong.js";
import Quanlyvipham from "views/Quanlyvipham/Quanlyvipham.js";
import Quanlyvanban from "views/Quanlyvanban/Quanlyvanban.js";
import Canhbao from "views/Canhbao/Canhbao.js";
import Quantringuoidung from "views/Quantringuoidung/Quantringuoidung.js";
import RolesMenuPermission from "views/RolesMenuPermission/RolesMenuPermission.js";

const quantri = [
  {
    path: "/submenudanhmucduongbo",
    name: "Danh mục đường bộ",
    rtlName: "قائمة الجدول",
    icon: MenuIcon,
    layout: "/admin",
    sub: 1,
    id: 6,
  },
  {
    path: "/danhmucdonvi",
    name: "Danh mục đơn vị KDVT",
    rtlName: "قائمة الجدول",
    icon: "content_paste",
    component: Danhmucdonvi,
    layout: "/admin",
    parent: 6,
  },
  {
    path: "/danhmucphuongtien",
    name: "Danh mục phương tiện",
    rtlName: "قائمة الجدول",
    icon: "content_paste",
    component: Danhmucphuongtien,
    layout: "/admin",
    parent: 6,
  },
  {
    path: "/danhmucbenxe",
    name: "Danh mục bến xe",
    rtlName: "قائمة الجدول",
    icon: "content_paste",
    component: Danhmucbenxe,
    layout: "/admin",
    parent: 6,
  },
  {
    path: "/danhmuctuyenxe",
    name: "Danh mục tuyến cố định",
    rtlName: "قائمة الجدول",
    icon: "content_paste",
    component: Danhmuctuyenxe,
    layout: "/admin",
    parent: 6,
  },
  {
    path: "/danhmuctuyenxebuyt",
    name: "Danh mục tuyến xe buýt",
    rtlName: "قائمة الجدول",
    icon: "content_paste",
    component: Danhmuctuyenxebuyt,
    layout: "/admin",
    parent: 6,
  },
  {
    path: "/danhmucxedien",
    name: "Danh mục xe điện",
    rtlName: "قائمة الجدول",
    icon: "content_paste",
    component: Danhmucxedien,
    layout: "/admin",
    parent: 6,
  },
  {
    path: "/danhmuctuyenxedien",
    name: "Danh mục tuyến xe điện",
    rtlName: "قائمة الجدول",
    icon: "content_paste",
    component: Danhmuctuyenxedien,
    layout: "/admin",
    parent: 6,
  },
  {
    path: "/danhmuctrungtamdangkiem",
    name: "Trung tâm đăng kiểm",
    rtlName: "قائمة الجدول",
    icon: "content_paste",
    component: Danhmucttdangkiem,
    layout: "/admin",
    parent: 6,
  },
  {
    path: "/cosodaotao",
    name: "Cơ sở đào tạo lái xe",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Cosodaotao,
    layout: "/admin",
    parent: 6,
  },
  {
    path: "/trungtamsathach",
    name: "Trung tâm sát hạch lái xe",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Trungtamsathach,
    layout: "/admin",
    parent: 6,
  },
  {
    path: "/danhmucdungchung",
    name: "Danh mục dùng chung",
    rtlName: "قائمة الجدول",
    icon: "content_paste",
    component: Danhmucdungchung,
    layout: "/admin",
    parent: 6,
  },
  {
    path: "/tracuuthongtin",
    name: "Tra cứu thông tin",
    rtlName: "قائمة الجدول",
    icon: InfoIcon,
    component: Tracuuthongtin,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/xacnhanhopdong",
    name: "Hợp đồng vận tải hành khách",
    rtlName: "قائمة الجدول",
    icon: StickyNote2Icon,
    component: Xacnhanhopdong,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/quantriquanlyvipham",
    name: "Quản lý vi phạm",
    rtlName: "قائمة الجدول",
    icon: DepartureBoardIcon,
    component: Quanlyvipham,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/quanlyvanban",
    name: "Quản lý văn bản",
    rtlName: "قائمة الجدول",
    icon: MenuBookIcon,
    component: Quanlyvanban,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/canhbao",
    name: "Cảnh báo",
    rtlName: "قائمة الجدول",
    icon: WarningIcon,
    component: Canhbao,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/quantringuoidung",
    name: "Quản trị người dùng",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Quantringuoidung,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/rolesmenupermission",
    name: "Role And Permission",
    rtlName: "قائمة الجدول",
    icon: AdminPanelSettingsIcon,
    component: RolesMenuPermission,
    layout: "/admin",
    sub: 0,
  },
];

export default quantri;
